import { Host, h } from '@stencil/core';
import { getDataAttributes } from '@pes-ui/utils';
export class AddToFavoriteButton {
  constructor() {
    this.isInList = false;
    this.button = { isShown: false };
  }
  render() {
    let buttonProps = {
      'data-da-element-id': 'add_p',
      'data-autotests-id': 'uiaas-product-card-cta-add-to-my-products',
    };
    if (this.button.dataset) {
      const { dataset = {} } = this.button;
      const dataProps = getDataAttributes(dataset);
      buttonProps = Object.assign(Object.assign({}, buttonProps), dataProps);
    }
    return (h(Host, Object.assign({ role: "button", class: this.isInList
        ? 'btn-link button--add-to-favorite is-added'
        : 'btn-link button--add-to-favorite' }, buttonProps), this.isInList ? (h("div", { class: "icon-remove" }, h("pes-icon", { customStyle: { fontSize: '22px' } }, "star_plain"))) : (h("div", { class: "icon-add" }, h("pes-icon", { customStyle: { fontSize: '22px' } }, "star_stroke")))));
  }
  static get is() { return "add-to-favorite-button"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["add-to-favorite-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["add-to-favorite-button.css"]
    };
  }
  static get properties() {
    return {
      "isInList": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If product is already added into list"
        },
        "attribute": "is-in-list",
        "reflect": false,
        "defaultValue": "false"
      },
      "button": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TCTAButtonSettings",
          "resolved": "TBaseCTAButtonSettings & { labels?: { addLabel?: string; removeLabel?: string; }; icons?: { addIcon?: string; removeIcon?: string; disableIconInPdpCtaBlock?: boolean; }; }",
          "references": {
            "TCTAButtonSettings": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Button settings."
        },
        "defaultValue": "{ isShown: false }"
      }
    };
  }
}
